<template>
    <v-row>
        <v-col class="d-flex align-center justify-space-between">
            <span>
                <span
                    class="mx-2 font-weight-light"
                >
                    Welcome
                </span>
                <span
                    class="text-h6 font-italic primary--text"
                >
                    {{ user.name }}
                </span>

            </span>
            <span class="font-weight-bold primary--text">  
                STUDENT ID#{{  user.student_id }}
            </span>
            
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
             user: 'auth/getUser',
        })
    }
}
</script>